import { createTheme, Theme } from "@mui/material/styles";
import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";

export const createTypographyTheme = (baseTheme: Theme, paletteTheme: SenecFPPTheme) => {
    return createTheme(paletteTheme, {
        typography: {
            fontFamily: "EnBW DIN Pro, sans-serif",
            fontSize: 16,
            h1: {
                fontFamily: "Mark Pro, sans-serif",
                fontSize: 30,
                lineHeight: "115%",
                fontWeight: 500,
                [baseTheme.breakpoints.up("sm")]: {
                    fontSize: 32,
                },
                [baseTheme.breakpoints.up("lg")]: {
                    fontSize: 36,
                    lineHeight: "110%",
                },
                letterSpacing: 0,
            },
            h2: {
                fontFamily: "Mark Pro, sans-serif",
                fontSize: 24,
                lineHeight: "125%",
                fontWeight: 500,
                [baseTheme.breakpoints.up("md")]: {
                    fontSize: 26,
                },
                [baseTheme.breakpoints.up("lg")]: {
                    fontSize: 28,
                },
                letterSpacing: 0,
            },
            h3: {
                fontFamily: "Mark Pro, sans-serif",
                fontSize: 20,
                lineHeight: "140%",
                fontWeight: 500,
                [baseTheme.breakpoints.up("md")]: {
                    fontSize: 22,
                    lineHeight: "125%",
                },
                [baseTheme.breakpoints.up("lg")]: {
                    fontSize: 24,
                    lineHeight: "125%",
                },
                letterSpacing: 0,
            },
            h4: {
                fontFamily: "Mark Pro, sans-serif",
                fontSize: 18,
                lineHeight: "140%",
                fontWeight: 500,
                [baseTheme.breakpoints.up("md")]: {
                    fontSize: 18,
                },
                [baseTheme.breakpoints.up("lg")]: {
                    fontSize: 20,
                },
                letterSpacing: 0,
            },
            h5: {
                fontFamily: "Mark Pro, sans-serif",
                fontSize: 16,
                lineHeight: "150%",
                fontWeight: 500,
                [baseTheme.breakpoints.up("md")]: {
                    fontSize: 16,
                },
                [baseTheme.breakpoints.up("lg")]: {
                    fontSize: 16,
                },
                letterSpacing: 0,
            },
            h6: {
                fontFamily: "Mark Pro, sans-serif",
                fontSize: 14,
                lineHeight: "150%",
                fontWeight: 500,
                [baseTheme.breakpoints.up("md")]: {
                    fontSize: 14,
                },
                [baseTheme.breakpoints.up("lg")]: {
                    fontSize: 14,
                },
                letterSpacing: 0,
            },
            s1: {
                fontFamily: "EnBW DIN Pro, sans-serif",
                fontSize: 14,
                lineHeight: "130%",
                [baseTheme.breakpoints.up("md")]: {
                    fontSize: 14,
                    lineHeight: "150%",
                },
                [baseTheme.breakpoints.up("lg")]: {
                    fontSize: 14,
                    lineHeight: "150%",
                },
            },
            s1Medium: {
                fontFamily: "EnBW DIN Pro Medium, sans-serif",
                fontSize: 14,
                lineHeight: "130%",
                [baseTheme.breakpoints.up("md")]: {
                    fontSize: 14,
                    lineHeight: "150%",
                },
                [baseTheme.breakpoints.up("lg")]: {
                    fontSize: 14,
                    lineHeight: "150%",
                },
            },
            s1Bold: {
                fontFamily: "EnBW DIN Pro Medium, sans-serif",
                fontSize: 14,
                fontWeight: 500,
                lineHeight: "130%",
                [baseTheme.breakpoints.up("md")]: {
                    fontSize: 14,
                    lineHeight: "150%",
                },
                [baseTheme.breakpoints.up("lg")]: {
                    fontSize: 14,
                    lineHeight: "150%",
                },
            },
            s2: {
                fontFamily: "EnBW DIN Pro, sans-serif",
                fontSize: 12,
                lineHeight: "130%",
                [baseTheme.breakpoints.up("md")]: {
                    fontSize: 12,
                },
                [baseTheme.breakpoints.up("lg")]: {
                    fontSize: 12,
                    lineHeight: "150%",
                },
            },
            s2Medium: {
                fontFamily: "EnBW DIN Pro Medium, sans-serif",
                fontSize: 12,
                lineHeight: "130%",
                [baseTheme.breakpoints.up("md")]: {
                    fontSize: 12,
                },
                [baseTheme.breakpoints.up("lg")]: {
                    fontSize: 12,
                },
            },
            body1: {
                fontFamily: "EnBW DIN Pro, sans-serif",
                fontSize: 16,
                lineHeight: "150%",
                letterSpacing: 0,
            },
            body1Responsive: {
                fontFamily: "EnBW DIN Pro, sans-serif",
                fontSize: 16,
                [baseTheme.breakpoints.up("md")]: {
                    fontSize: 17,
                },
                [baseTheme.breakpoints.up("lg")]: {
                    fontSize: 18,
                },
                letterSpacing: 0,
            },
            body1Medium: {
                fontFamily: "EnBW DIN Pro Medium, sans-serif",
                fontSize: 16,
                lineHeight: "150%",
                [baseTheme.breakpoints.up("md")]: {
                    fontSize: 16,
                },
                [baseTheme.breakpoints.up("lg")]: {
                    fontSize: 16,
                },
                letterSpacing: 0,
            },
            /**
             * @deprecated body2 use body1Responsive instead
             */
            body2: {
                fontFamily: "EnBW DIN Pro, sans-serif",
                fontSize: 16,
                [baseTheme.breakpoints.up("md")]: {
                    fontSize: 17,
                },
                [baseTheme.breakpoints.up("lg")]: {
                    fontSize: 18,
                },
                letterSpacing: 0,
            },
            button: {
                fontFamily: "Mark Pro, sans-serif",
                fontSize: 17,
                lineHeight: "265%",
                fontStyle: "normal !important",
                textTransform: "none",
            },
            buttonSmall: {
                fontFamily: "Mark Pro, sans-serif",
                fontSize: 15,
                lineHeight: "265%",
                fontStyle: "normal !important",
                textTransform: "none",
            },
            subtitle1: {
                fontFamily: "EnBW DIN Pro, sans-serif",
                fontSize: 12,
                fontWeight: 400,
                lineHeight: "130%",
                whiteSpace: "pre-wrap",
            },
            enbwTabletP1: {
                fontFamily: "EnBW DIN Pro, sans-serif",
                fontSize: 17,
                fontStyle: "normal !important",
                textTransform: "none",
            },
            enbwTabletS1: {
                fontFamily: "EnBW DIN Pro, sans-serif",
                fontSize: 15,
                fontStyle: "normal !important",
                textTransform: "none",
            },
            enbwTabletS1Medium: {
                fontFamily: "EnBW DIN Pro Medium, sans-serif",
                fontSize: 15,
                lineHeight: "150%",
                fontStyle: "normal !important",
                textTransform: "none",
            },
            enbwTabletS2Small: {
                fontFamily: "EnBW DIN Pro Medium, sans-serif",
                fontSize: 13,
                lineHeight: "130%",
                fontStyle: "normal !important",
                textTransform: "none",
            },
        },
    });
};
